<template>
  <div v-if="!dailyEffortsPresenter.hasData.value" class="w-full h-full flex justify-center items-center">
    {{ $t('message.noData') }}
  </div>
  <VueApexCharts
    v-else
    height="100%"
    :options="dailyEffortsPresenter.chartOptions.value"
    :series="dailyEffortsPresenter.chartSeries.value"
    type="line"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import VueApexCharts from 'vue3-apexcharts'

import { useDailyEffortsPresenter } from '@/presentation/composables/dashboard/useDailyEffortsPresenter'

export default defineComponent({
  components: { VueApexCharts },
  setup(props, ctx) {
    const dailyEffortsPresenter = useDailyEffortsPresenter()

    return {
      dailyEffortsPresenter
    }
  }
})
</script>

<style lang="postcss" scoped></style>
